import Storage from "../services/Storage";
import { FulfillOption as FulfillOptionConst } from "./../constants";

const initState = {
    Summary: {
        LastSyncUTC: undefined,
        Error: 0,
        ReadyToPrint: 0,
        ReadyToShip: 0,
        FulfillmentFlg: false,
        InProcess: 0,
        CompletedProcess: 0,
        WMSAutoSendFlg: null,
    },
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'ON_LOAD_HEADER_SUMMARY':
            return { ...state, Summary: action.payload }
        case 'ON_LOAD_PRINTER': {
            return { ...state, Printer: action.payload }
        }
        case 'GET_HEADER_SUMMARY_SUCCESS': {
            if (action.payload.data.data.FulfillmentFlg) {
                Storage.set('FulfillmentFlg', 1)
            } else {
                Storage.set('FulfillmentFlg', 0)
            }
            
            Storage.set('LabelPrintFlgs', action.payload.data.data.LabelPrintFlgs) 

            return {
                ...state,
                Summary: action.payload.data.data
            }
        }
        case 'FROM_SUMMARY_HEADER': {
            return {
                ...state,
                fromSummary: action.payload.fromSummary,
                tab: action.payload.tab,
            }
        }
        case 'RESET_SUMMARY_HEADER' : {
            return initState
        }
        case 'GET_SHIPMENT_SUCCESS': {
            let data = action.json.data.data;
            if (data.FulfillmentOption === FulfillOptionConst.YAMATO.CODE) {
                return {
                    ...state,
                    Summary: {
                        ...state.Summary,
                        InProcess: data.FulfillmentInProcessCount,
                        CompletedProcess: data.FulfillmentCompletedCount
                    }
                }
            } else {
                return {
                    ...state,
                    Summary: {
                        ...state.Summary,
                        ReadyToPrint: data.ReadyToPrintCount,
                        ReadyToShip: data.ReadyToTransmitCount,
                    }
                }
            }
            
        }
        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/headerReducer.js